document.addEventListener('DOMContentLoaded', function () {
  const quickViewButtons = document.querySelectorAll('.show-product-quickview');

  quickViewButtons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      try {
        console.log("hi")
        setTimeout(() => {
          const dataPrice = document.querySelector('[data-price]');
        updateQuickSearchCurrency(dataPrice);
        const dataComparePrice=document.querySelector("[data-compare-price]");
        updateQuickSearchCurrency(dataComparePrice);
        }, 2000);
        const productData = JSON.parse(btn.getAttribute('data-product'));
        quickViewCovertCurrency(productData);
      } catch (err) {
        console.error('Invalid product data', err);
      }
    });
  });
});